import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {
  cpConfigurationData: [],
  blockedMacs: []
}
const mutations = {
  SET_CPCONFIGURATON_DATA(state, data) {
    state.cpConfigurationData = data;

  },
  SET_BLOCKED_MACS(state, data) {
    state.blockedMacs = data
  }

}
const actions = {
  fetchCpConfigurationDatas({
    commit,
    dispatch
  }, authData) {
    Nprogress.start();
    axios.get('/CpConfiguration/cpConfig_list')
      .then(res => {
        Nprogress.done()
        if (res.data.status == "redirect") {
          router.push("/dashboard");
        }
        else{
        commit("SET_CPCONFIGURATON_DATA", JSON.parse(res.data.message));
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },
  fetchBlockedMacsDatas({
    commit,
    dispatch
  }, authData) {
    Nprogress.start();
    axios.get('/captive_portal_settings/blocked_macs_vue')
      .then(res => {
        Nprogress.done()
        if (res.data.status == "redirect") {
          router.push("/dashboard");
        }
        else{
        commit("SET_BLOCKED_MACS", JSON.parse(res.data.message));
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status == 403) {
            window.location = "/dashboard";
          }
        }
      })
  },
  socialLogOnLike({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/CpConfiguration/social_logon_like', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status == "redirect") {
            router.push("/dashboard");
        }
        else if (response.data.status != 'success') {
            reject(response.data.message);
            return;
        }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  applyToAllSubZone({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('CpConfiguration/add_all_cpconfiguration_to_subaccounts', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if(response.data.status=='redirect')
          {
            router.push("/dashboard");
          }
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  saveBlockedMacs({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/captive_portal_settings/save_blocked_macs', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if(response.data.status=='redirect')
          {
            router.push("/dashboard");
          }
          else if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
}
const getters = {
  cpConfigurationGetter: state => {
    return state.cpConfigurationData
  },
  blockedMacGetters: state => {
    return state.blockedMacs;
  }
}
export default {
  state,
  mutations,
  actions,
  getters
}

